import { SubDevicesDto } from 'src/Libs/flow/installation/api/sub-devices'
import { PowermeterHardwareModel } from 'src/State/Storage/StorageModel'

/**
 * Flow theme only: keep powermeters that match a sub-device meter,
 * and replace their display name with the sub-device's deviceName.
 *
 * Matching is by deviceID[1] OR id/index — the dual key exists because legacy
 * and new devices identify themselves differently. See AF-5388.
 */
export const applyFlowSubDeviceNames = (
  powermeters: PowermeterHardwareModel[],
  subDevices: Nullable<SubDevicesDto> | undefined
): PowermeterHardwareModel[] =>
  powermeters.flatMap(powermeter => {
    const subDevice = subDevices?.monitoring?.meters?.find(m => m.id === powermeter.deviceID?.[1] || m.index === powermeter.id)
    if (!subDevice) return []
    if (subDevice.deviceName && powermeter.name) {
      return [
        {
          ...powermeter,
          name: [powermeter.name[0], subDevice.deviceName] as [number, string],
        },
      ]
    }
    return [powermeter]
  })
